import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';
import { BaseMember } from './../base-member';

@Component({
  selector: 'app-member-disable',
  templateUrl: './member-disable.component.html',
  styleUrls: ['./member-disable.component.css'],
  providers: [MemberService, MessageEvent, SignInEvent, AppService, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck, UtilityFunctions]
})
export class MemberDisableComponent extends BaseMember implements OnInit {
  private stringConstants = CONSTANT_MESSAGES;
  private shouldSlide: boolean = false;
  private hideEdit: boolean;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private height: any;
  private divHeight = 30;
  private pagebutton = 20;
  private selectMember;
  private scrollOptions: ISlimScrollOptions;
  private disableMembers = '';
  private selectMemberFlag = false;
  private disableMemberList = [];
  private disableMemberObj = {
    'userIds': [],
    'facilityId': '',
    'facilityName': '',
    'vendorId': '',
    'reason': '',
    'startTime': '',
    'endTime': '',
    'clubName': ''

  };
  private exp;
  private disableSelectMember = false;
  private enableButton = false;
  private allInGroup = false;
  @ViewChild('memberTable')
  tableVariable: any;
  private totalSizeOfList = 0;
  private onePagePerItem = 10;  // It will set by vendor configuration object
  private currentPage = 1;
  private currentFrame = 'ALL';
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };
  private filterPara = '';
  private message = '';
  private memberTableHeight = 0;
  private changeTableSize = 55;
  private clubName = '';
  private setChecked = [];
  private showFilterGroup = false;
  private showFilterPreference = false;
  private selectItem = false;
  private userIdListForDisable = [];
  private disabledFacilityIdList = [];
  private userIdForDisable = [];
  private noMemberAvailableInFilter = false;
  private frameType = 'ALL';
  private filterSendInvite = false;
  private sendInviteFliterList = [{ name: 'Sent', status: true }, { name: 'Not Sent', status: false }];
  constructor(private router: Router, private memberService: MemberService, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private hiddenFooter: HiddenFooter,
    private signInEvent: SignInEvent, private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory, private setAllMemberCheck: SetAllMemberCheck) {
    super();
    this.popUpMessage = '';
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };
    this.hideEdit = false;
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight
      + this.pagebutton)) + 'px';
    this.selectMember = false;
    this.exp = false;
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
  }

  ngOnInit() {
    let obj = {
      category: 'Disable Members',
      menu: 'Disable Members'
    };
    this.sidemenuSubCategory.fire(obj);

    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor.clubName;
    }
    this.getFacilityListForMemberFilter(this);
    this.getGroupListForFilter(this);
    this.pagination(this.pageOptions, 1, 'ALL');
    this.emitOpenFrameEvent();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
  }

  /**
   * Temproray function
   */
  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }

  /**
   * Retrive MemberList with respect to condo
   */
  getMemberListByVendor(vendorObj) {
    let that = this;
    try {
      this.loaderEvent.fire(false);
      this.appService.getListOfMember(vendorObj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.memberList = result.memberList;
          this.totalSizeOfList = result.total;
          this.memberList.map(function (mem) {
            if (!mem.isBlackListed) {
              mem.enable = 'Active';
            } else {
              mem.enable = 'Inactive';
            }
            mem.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
            if (mem.hasLeftService) {
              mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
            }
            return mem;
          });
          if (this.memberList.length === 0) {
            this.noMemberAvailable = false;
          } else {
            this.noMemberAvailable = true;
            this.setCheckedList();
          }
          if (vendorObj['filters'].length >= 1) {
            this.noMemberAvailableInFilter = true;
          } else {
            this.noMemberAvailableInFilter = false;
          }
          this.setAllMemberCheck.fire(true);
          this.loaderEvent.fire(true);
        }
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * TO change status of member if payment is done
   */
  onNotify(message: boolean): void {
    this.memberList.map(function (mem) {
      mem.isChecked = false;
      return mem;
    });
    this.reset();
  }

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too by broadcaster
   */
  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
  }

  redirectToAllMember() {
    this.router.navigate(['/member']);
  }

  expand() {
    if ((this.searchMember + '').trim()) {
      if (this.currentFrame === 'DISABLE') {
        this.pagination(this.pageOptions, 1, 'DISABLE');
      } else if (this.currentFrame === 'ENABLE') {
        this.pagination(this.pageOptions, 1, 'ENABLE');
      } else {
        this.pagination(this.pageOptions, 1, 'SEARCH');
      }
    } else {
      if (this.exp) {
        this.pagination(this.pageOptions, 1, 'ALL');
      }
      this.exp = !this.exp;
    }
  }

  /**
   * Change frame either disable or enable
   */
  redirectToDisableMember(str) {
    try {
      this.selectMemberFlag = true;
      this.currentFrame = str;
      this.setChecked = [];
      this.disableMemberObj.userIds = [];
      if (this.currentFrame == 'DISABLE') {
        this.disableSelectMember = true;
      } else {
        this.disableSelectMember = false;
      }
      this.memberTableHeight = this.changeTableSize;
      if (this.tableVariable.allInGroup) {
        this.tableVariable.allInGroup = false;
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Show confirmation popup
   */
  disableMembersForFacility(popUpObj, disablePopupObj) {
    try {
      if (this.disableMemberObj.userIds.length === 0) {
        this.popUpMessage = CONSTANT_MESSAGES.DESABLE_MEMBER;
        popUpObj.showChildModal(1);
        return;
      } else {
        disablePopupObj.showChildModal();
      }
    } catch (err) {
      console.log(err);
    }
  }
  /**
   * Make multiple member disable
   */
  disableMember(disableObj: any, popUpObj: any) {
    try {
      let that = this;
      this.disableMemberObj.facilityName = disableObj.facility.name;
      this.disableMemberObj.facilityId = disableObj.facility._id;
      this.disableMemberObj.vendorId = this.vendor._id;
      this.disableMemberObj.reason = disableObj.reason;
      this.disableMemberObj.startTime = that.utilityFunctions.maketimeZoneOfsetDate(disableObj.startTime, true);
      this.disableMemberObj.endTime = that.utilityFunctions.maketimeZoneOfsetDate(disableObj.endTime, true);
      let userList = JSON.parse(JSON.stringify(this.disableMemberObj.userIds));
      this.disableMemberObj.userIds = [];
      this.disableMemberObj.clubName = this.vendor.clubName;
      userList.map(function (rec) {
        if (rec) {
          that.disableMemberObj.userIds.push(rec);
        }
      });
      this.loaderEvent.fire(false);
      this.memberService.disableMemberForSpecificFacility(this.disableMemberObj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.popupTitle = ""
        } else {
        }
        this.popUpMessage = result.message;
        popUpObj.showChildModal();
        this.loaderEvent.fire(true);
        this.memberList.map(function (mem) {
          mem.isChecked = false;
          return mem;
        });
        if (this.tableVariable.allInGroup) {
          this.tableVariable.allInGroup = false;
        }
        this.loaderEvent.fire(true);
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });

    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Insert members in list to make them disable
   */
  addMemberInDisableList(memberObj: any) {
    if (memberObj.isChecked) {
      this.disableMemberObj.userIds.push(memberObj.userId);
      this.setChecked.push(memberObj.userId);
    } else {
      _.remove(this.disableMemberObj.userIds, function (n) {
        return n === memberObj.userId;
      });
      _.remove(this.setChecked, function (n) {
        return n === memberObj.userId;
      });
      if (this.tableVariable.allInGroup) {
        this.tableVariable.allInGroup = false;
      }
    }
    if (this.disableMemberObj.userIds.length === 0) {
      this.disableSelectMember = false;
      this.tableVariable.allInGroup = false;

    }
  }
  /**
   * Insert all members on current page in list to make them disable
   */
  makeAllMemberDisable(memberList: any) {
    try {
      this.setChecked = this.setChecked.concat(memberList);
      this.setuserIdListForDisable();
      this.disableMemberObj.userIds = this.userIdListForDisable;
      this.disableSelectMember = true;
      if (!this.tableVariable.allInGroup) {
        this.disableSelectMember = false;
        this.disableMemberObj.userIds = [];
        this.setChecked = _.difference(this.setChecked, memberList);
      } else {

      }
    } catch (e) {
      console.log(e);
    }
  }

  disableSelectMemberOnCheck(bool: boolean) {
    try {
      if (!this.disableSelectMember) {
        this.disableSelectMember = bool;
      }
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Insert all members on current page in list to make them disable
   */
  enableMembers(enableFacilityList: any, popUpObj) {
    try {
      let enableObj = {
        'userIds': this.disableMemberObj.userIds,
        'facilityIds': enableFacilityList,
        'vendorId': this.vendor._id

      };
      this.loaderEvent.fire(true);
      this.memberService.enableMembers(enableObj).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        } else {
        }
        this.popUpMessage = result.message;
        popUpObj.showChildModal();
        this.loaderEvent.fire(true);
        this.memberList.map(function (mem) {
          mem.isChecked = false;
          return mem;
        });
        if (this.tableVariable.allInGroup) {
          this.tableVariable.allInGroup = false;
        }
        this.loaderEvent.fire(true);
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Show popup for enable members
   */
  enableMemberShowPopup(popUpObj, enablePopupObj) {
    try {
      if (this.disableMemberObj.userIds.length > 0) {
        enablePopupObj.showChildModal();
      } else {
        this.popUpMessage = CONSTANT_MESSAGES.ENABLE_MEMBER;
        popUpObj.showChildModal(1);
      }
    } catch (e) {
      console.log(e);
    }
  }

  reset() {
    try {
      this.allInGroup = false;
      this.disableSelectMember = false;
      this.selectMemberFlag = false;
      this.enableButton = false;
      this.disableMemberObj.userIds = [];
      this.currentFrame = 'ALL';
      this.memberTableHeight = 0;
      this.maintainFilterState();
      this.pagination(this.pageOptions, 1, this.currentFrame);
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Apply pagination, filter and search to get member list
   *
   * @param {any} pageOptions
   * @param {any} pageNo
   * @param {any} currentFrame
   *
   * @memberof MemberDisableComponent
   */
  pagination(pageOptions, pageNo, currentFrame) {
    try {
      this.filterState = this.filterPara;
      if (pageOptions) {
        this.pageOptions = pageOptions;
      }
      let vendorObject = this.setVendorIdAsPerRole(this, pageNo);
      this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
      vendorObject = this.setFilterAsPerFrame(vendorObject, currentFrame);
      this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED_MESSAGE;

      switch (this.filterPara) {
        case 'Inactive':
          vendorObject['filters'].push({
            type: 'isDeactivated',
            values: true
          });
          this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
          this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
          break;
        case 'DisabledFacility':
          vendorObject['filters'].push({
            type: 'disabled',
            values: this.facilityFilter,
            applyAll: false
          });
          this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
          this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
          this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
          break;
        case 'Prefernces':
          vendorObject['filters'].push({
            type: 'facilityPreference',
            values: this.preferenceFilter,
            applyAll: false
          });
          this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
          this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
          this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
          break;
        case 'Groups':
          vendorObject['filters'].push({
            type: 'group',
            values: this.groupFilter,
            applyAll: false
          });
          this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.groupFilter));
          this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
          this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
          break;
        case 'DisablePage':
          this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
          vendorObject['filters'].push({
            type: 'isDisabled',
            values: true
          });
          this.filterPara = '';
          break;
        case 'SentInvite':
          if (this.inviteStatusFilter.indexOf(true) >= 0 && this.inviteStatusFilter.indexOf(false) < 0) {
            vendorObject['filters'].push({
              type: 'isInviteSent',
              values: true
            });
          }
          if (this.inviteStatusFilter.indexOf(false) >= 0 && this.inviteStatusFilter.indexOf(true) < 0) {
            vendorObject['filters'].push({
              type: 'isInviteSent',
              values: false
            });
          }
          if (this.inviteStatusFilter.length == 0) {
            vendorObject['filters'] = [];
          }
          this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.inviteStatusFilter));
          this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
          break;
      }

      if ((this.searchMember + '').trim()) {
        vendorObject['filters'].push({
          type: 'search',
          values: this.searchMember
        });
        this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
      }
      this.getMemberListByVendor(vendorObject);
    } catch (e) {
      console.log(e);
    }
  }
  /**
       * Add facility in list to filter by disable facility
       */
  addFacilityForFilter(e, facilityId) {
    this.utilityFunctions.addFacilityForFilter(this, e, facilityId);
  }
  /**
       * Add group in list to filter by group
       */
  addGroupForFilter(e, groupId) {
    this.utilityFunctions.addGroupForFilter(this, e, groupId);
  }
  /**
       * Add facility in list to filter by preference
       */
  addPreferencesForFilter(e, facilityId) {
    this.utilityFunctions.addPreferencesForFilter(this, e, facilityId);
  }

  addInviteStatusForFilter(e, status) {
    this.utilityFunctions.addInviteStatusForFilter(this, e, status);
  }

  /**
       * Select filter criteria
       */
  setFilterCriteria(para) {
    this.utilityFunctions.setFilterCriteria(this, para);
  }

  /**
       * Store selected list
       */
  setCheckedList() {
    try {
      let flagAllChecked = true;
      for (let rec of this.setChecked) {
        for (let mem of this.memberList) {
          if (rec === mem.userId) {
            mem.isChecked = true;
            break;
          }
        }
      }
      for (let mem of this.memberList) {
        if (!mem.isChecked) {
          flagAllChecked = false;
          break;
        }
      }
      if (flagAllChecked) {
        this.tableVariable.allInGroup = true;
      } else {
        this.tableVariable.allInGroup = false;
      }
    } catch (e) {
      console.log(e);
    }
  }
  /**
       * Maintain filter state
       */
  maintainFilterState() {
    this.utilityFunctions.maintainFilterState(this);
  }

  setuserIdListForDisable() {
    for (let rec of this.setChecked) {
      for (let mem of this.memberList) {
        if (rec === mem.userId) {
          this.userIdListForDisable.push(mem.userId);
          break;
        }
      }
    }
  }

  setAllUncheck() {
    if (this.facilityFilter.length == 0 && this.preferenceFilter.length == 0 && this.groupFilter.length == 0) {
      this.filterPara = 'ALL';
      this.filterState = 'ALL';
      this.setFilterCriteria('ALL');
    }
  }
  /**
   * Change frame as per requirement
   *
   * @param {any} vendorObject
   * @param {any} currentFrame
   * @returns
   *
   * @memberof MemberDisableComponent
   */
  setFilterAsPerFrame(vendorObject, currentFrame) {
    if ((this.currentFrame === 'ALL' || this.currentFrame === 'ENABLE')) {
      vendorObject['filters'].push({
        type: 'isDisabled',
        values: true
      });
    } else {
      if (this.currentFrame === 'DISABLE') {
      } else if (this.currentFrame === 'ENABLE') {
        vendorObject['filters'].push({
          type: 'isDisabled',
          values: true
        });
      } else if (currentFrame === 'SEARCH') {
        this.filterPara = 'DisablePage';
      }
    }
    return vendorObject;;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-disable/member-disable.component.ts